import { Theme, ThemeId } from './types';
import { classicTheme } from './classic';
import { retro8BitTheme } from './retro-8bit';
import { halloweenTheme } from './halloween';

// Theme registry
const themes: Record<ThemeId, Theme> = {
  'classic': classicTheme,
  'retro-8bit': retro8BitTheme,
  'halloween': halloweenTheme,
};

export function getTheme(themeId: ThemeId): Theme {
  return themes[themeId] || themes.classic;
}

export function getAllThemes(): Theme[] {
  return Object.values(themes);
}

export * from './types';
export { classicTheme, retro8BitTheme, halloweenTheme };